<template>
  <div>
      <AddCompanyEmisorasForm></AddCompanyEmisorasForm>
  </div>
</template>

<script>
import AddCompanyEmisorasForm from '@/components/Dashboard/CompaniesEmisoras/AddCompanyEmisorasForm'
export default {
  components: { AddCompanyEmisorasForm },

}
</script>